import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-confirm-subscription',
  templateUrl: './confirm-subscription.page.html',
  styleUrls: ['./confirm-subscription.page.scss'],
})
export class ConfirmSubscriptionPage implements OnInit {
  @Input() oldMethod
  @Input() newMethod
  @Input() type
  constructor(
    private alertController: AlertController,
    private loaderSRV:LoaderService,
    private dataService: DataService,
    public modalController: ModalController,
    public translateService: TranslateService,
    private errorHandlerSRV:ErrorHandlerService,
  ) {
    
    
   }

  ngOnInit() {
    
  }
  cancel(){
    this.modalController.dismiss({status:"cancel"})
  }
  replace(){
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.payments.subscribing') || 'Subscribing...')
    this.dataService.postData(`account/subscriptions/activate/${this.type}/endpoint`,{'selection':this.newMethod['PaymentTypeID']+':'+this.newMethod['detailid']}).subscribe({
      next:async res=>{
        if(res['status']=="success"){
          this.loaderSRV.dismissLoader()
          this.modalController.dismiss({status:"success"})
        } else{
          this.loaderSRV.dismissLoader()
          this.modalController.dismiss({status:"cancel"})
          this.errorHandlerSRV.displayErrorMessage(res,true)
          
        }
      },
      error:async err=>{
        this.modalController.dismiss({status:"cancel"})
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
      
      
    
      
    })
  }

}
